export default {"src":"/_next/static/media/video.d5bd94dc.svg","height":42,"width":47,"blurWidth":0,"blurHeight":0};